import {ItemStatus, ItemType, WeightCategory, WeightUnit} from "../enums/item-enums";

export default class PickItem {

    /**
     *
     * @param {Item} item
     * @returns {PickItem}
     */
    static getInstanceFromItem(item) {
        const pickItem = new PickItem();
        pickItem.itemId = item.itemId;
        pickItem.itemStatus = item.itemStatus;
        pickItem.aisle = item.location ? item.location.aisle : "";
        pickItem.bin = item.location ? item.location.bin : "";
        pickItem.rack = item.location ? item.location.rack : "";
        pickItem.scannableIds = [item.scannableId];
        pickItem.itemType = item.itemType;
        pickItem.label = item.label;
        pickItem.color = item.containerColor;
        pickItem.weight = item.weight;
        pickItem.sequence = item.sequence;
        return  pickItem;
    }

    constructor() {
        this.itemId = "Bag-78";
        this.scannableIds = ["scan1", "scan2"];
        this.itemStatus = ItemStatus.MISSED_TEMP;
        this.isMissedEver = true;
        this.itemType = ItemType.PACKAGE;
        this.aisle = "A1";
        this.bin = "2B";
        this.color = "green";
        this.label = "itemLabel";
        this.rack = "R1";
        this.weight = {
            value : "2.1",
            unit: WeightUnit.KG,
            category: WeightCategory.NORMAL
        };
    }
}



// WEBPACK FOOTER //
// ./src/models/ui/pick-item.js